import React from "react";
import { MotionConfig } from "framer-motion";
import { NavigationList } from "~assets/frontend/frame/frm-navigation/components/NavigationList";
export const NavigationItemInline = (props) => {
    return (React.createElement("div", { className: "mb-36 py-12" },
        React.createElement("p", { className: "text-16 text-black-40" }, props.title),
        props.items && props.layer && (React.createElement(MotionConfig, { transition: { duration: 0 } },
            React.createElement(NavigationList, { label: null, href: null, mainItems: props.items, selected: props.selectedLocation, onSelect: props.onSelect, onDetail: props.onDetail, inline: true, layer: props.layer })))));
};
